import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { AiOutlineWifi } from "react-icons/ai";

import './CondCard.css';


const data =[
    {
        header:'Room only',
        svg: <AiOutlineWifi />,
        svgheader:'Free Wifi',
        dataContent: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy',
        price: 2400
    },
    {
        header:'Room + Breakfast',
        svg: <AiOutlineWifi />,
        svgheader:'Free Wifi',
        dataContent: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy',
        price: 2800
    },
    {
        header:'Room + Breakfast + Lunch',
        svg: <AiOutlineWifi />,
        svgheader:'Free Wifi',
        dataContent: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy',
        price: 3500
    }
]

function CondCard() {
    return (
        <Container fluid>
        {data.map((element,index)=>{
           return(
           
        
            <Row key={index} className='globalRow'>
                
                    <div className='divHeader'>
                        <h2>{element.header}</h2>
                    </div>
                <Col xl={7} lg={7} md={7} sm={7} xs={12} className='division1'>
                    
                    <div className='svgOuterBox'>
                        <span>{element.svg}</span>
                        <h3>{element.svgheader}</h3>
                    </div>
                    <div className='contenuBox'>
                        <p className='contenu'>{element.dataContent}</p>
                    </div>
                </Col>
                <Col xl={5} lg={5} md={5} sm={5} xs={12} className='division2'>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} className='priceOuterBox'>
                                <span className='priceN'>{element.price}</span>
                                <p className='unit'>INR/night</p>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} className='buttonOuterBox'>
                                <Button type='button' className='bookBtn'>Book Now</Button>
                        </Col>
                    </Row>
                    
                </Col>
                <hr style={{width:'80%', margin:'auto', marginTop:'5px'}}/>
            </Row>
           
         ) })}
        </Container>
    )
}

export default CondCard
